<template>
  <b-container>
    <b-list-group>
      <b-list-group-item class="text-left" v-for="item in domains" :key="item.domain">
        <b-row align-v="center">
          <b-col class="text-left" cols="9">{{ item.domain }}</b-col>
          <b-col class="text-right" cols="3"><b-button size="sm" variant="primary" v-on:click="selectDomain(item)">{{ $t('_login') }}</b-button></b-col>
        </b-row>
      </b-list-group-item>
    </b-list-group>
  </b-container>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'MultiDomainModal',
  props: {
    domains: {
      default: function () { return [] },
      type: Array
    },
    email: {
      default: '',
      type: String
    },
    password: {
      default: '',
      type: String
    }
  },
  computed: {
    ...mapGetters([
      'shappyInfo'
    ])
  },
  methods: {
    ...mapActions([
      'createShopByMultiVelaeasyLoginAPI'
    ]),
    close (node) {
      this.$emit('callback', node)
    },
    selectDomain (item) {
      let param = {'appID': this.shappyInfo.appId,
        'channelID': this.shappyInfo.channelId,
        'channelName': this.shappyInfo.channelName,
        'email': this.email,
        'password': this.password,
        'domain': this.shappyInfo.domain,
        'package': this.shappyInfo.package,
        'velaeasyDomain': item.domain,
        'velaeasyToken': item.token
      }
      this.createShopByMultiVelaeasyLoginAPI(param).then((result) => {
        if (result.status === 0 && result.data.publicShopKey) {
          this.$router.push({
            name: 'edit'
          })
        } else {

        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.list-group {
  height: 200px;
  overflow: auto;
  .list-group-item {
    border: none;
  }
}
</style>
